import { render, staticRenderFns } from "./SmartModel.vue?vue&type=template&id=49f50fe0&scoped=true&"
import script from "./SmartModel.vue?vue&type=script&lang=js&"
export * from "./SmartModel.vue?vue&type=script&lang=js&"
import style0 from "./SmartModel.vue?vue&type=style&index=0&id=49f50fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f50fe0",
  null
  
)

export default component.exports